import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_API_ENDPOINT

export const useDataProvider = () => {
    return {
        getIdeas: (data) => axios.post(`${BACKEND_URL}/get-information`, data),
    }
}